module.exports = __webpack_public_path__ + "static/media/balaji.5aa51d97.png";